export default "__VITE_ASSET__CzG0xCLP__"